// extracted by mini-css-extract-plugin
export default {"modalContent":"IndiaBusinessModal_modalContent__poWmn","infoText":"IndiaBusinessModal_infoText__fCQ93","formGrid":"IndiaBusinessModal_formGrid__hG2vU"};